import { Table } from "antd";
import { BreakerStepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import type { ColumnsType } from "antd/es/table";

interface BreakerRow {
    key: string;
    label: string;
    value: string;
}

export interface StepDetailBreakerProps {
    extractedData: BreakerStepSummary;
}

export const StepDetailBreaker: FC<StepDetailBreakerProps> = ({ extractedData }) => {
    const { t } = usePaldockTranslation("drawers.step-detail.breaker");

    const rows: BreakerRow[] = [
        {
            key: "repetitions",
            label: t("repetitions"),
            value: extractedData.repeats ?? "-",
        },
    ];

    const columns: ColumnsType<BreakerRow> = [
        { dataIndex: "label", key: "label" },
        { dataIndex: "value", key: "value" },
    ];

    return (
        <DrawerCollapsible title={t("data")}>
            <Table
                columns={columns}
                dataSource={rows}
                pagination={false}
                size="small"
                bordered={false}
                showHeader={false}
            />
        </DrawerCollapsible>
    );
};
